import React from "react"
import { EventTimeFormat } from "../../../util/dates"
import { Link, useLocation } from "react-router-dom"
import clsx from "clsx"
import { getTicketPriceDisplay } from "@util/ticketUtils"

export const ConcertFeedItem = ({ concert }) => {
  const location = useLocation()
  const acceptedCollaboratorNames = (concert.post_collaborators ?? [])
    .filter((c) => c.status === "accepted")
    .map((c) => c.band_name)

  const isFree =
    concert.ticket_type === "bNTickets"
      ? concert.pricing_type === "free"
      : !concert.pricing_type || concert.pricing_type === "free"

  const priceDisplay = !isFree ? getTicketPriceDisplay(concert) : null
  const hasPurchasedTicket = concert.user_has_purchased_ticket
  const ticketCount = concert.user_ticket_count || 0

  return (
    <li className="text-sm mb-4">
      <Link to={{ pathname: concert.nada_path, state: { from: location } }}>
        <>
          <div className="flex flex-wrap items-center gap-1">
            <div className="font-bold leading-tight uppercase text-sm text-gray-800">
              {concert.bn_venue
                ? concert.bn_venue.name
                : concert.venue_name ||
                  concert.venue_city_display_name ||
                  concert.title}
            </div>
            {hasPurchasedTicket && (
              <span className="inline-block text-xs font-medium bg-purple-100 text-purple-800 px-1 rounded">
                {ticketCount > 1
                  ? `${ticketCount} Tickets Purchased`
                  : "Ticket Purchased"}
              </span>
            )}
            {isFree ? (
              <span className="inline-block text-xs font-medium bg-blue-100 text-blue-800 px-1 rounded">
                Free
              </span>
            ) : priceDisplay ? (
              <span className="inline-block text-xs font-medium bg-gray-100 text-gray-700 px-1 rounded">
                {priceDisplay}
              </span>
            ) : null}
          </div>

          <div className={clsx("leading-tight text-sm text-gray-600")}>
            {EventTimeFormat(concert.start_dt, concert.timezone)}
            {concert.end_dt && concert.end_dt !== concert.start_dt && (
              <span>~{EventTimeFormat(concert.end_dt, concert.timezone)}</span>
            )}
          </div>
          <div
            className={clsx(
              "text-sm",
              (concert.status === "canceled" || concert.canceled_at) &&
                "text-bn-neon-red",
            )}
          >
            {concert.status === "canceled" || concert.canceled_at ? (
              <>
                Canceled! <span className="line-through">{concert.title}</span>
              </>
            ) : (
              <>
                {concert.title}
                {concert.status === "unpublished" && (
                  <span className="text-xs font-normal text-gray-500">
                    {" "}
                    (unlisted)
                  </span>
                )}
              </>
            )}
          </div>

          {concert.event_performances.length > 0 && (
            <div className="text-xs text-gray-500 leading-tight pb-1">
              w/{" "}
              <span className="text-sm text-gray-600">
                {concert.event_performances.map((p) => p.band_name).join(", ")}
              </span>
            </div>
          )}

          <div className="leading-none mb-1 text-xs text-gray-500 italic">
            Posted by {concert.band_name}
            {acceptedCollaboratorNames.length > 0 && ` w/ ${acceptedCollaboratorNames.join(", ")}`}
          </div>
        </>
      </Link>
    </li>
  )
}
